export default __webpack_public_path__ + "static/media/08-460x460.f25431a5.jpeg";